const Video = {
    init() {
        if (document.querySelector('.video')) {
            const videos = [...document.querySelectorAll('.video')];
            videos.forEach(video => {
                const vidBtn = video.querySelector('.video__play-btn');
                const videoTag = video.querySelector('video');
                let playing = video.classList.contains('playing');
                if (vidBtn) {
                    vidBtn.addEventListener('click', () => {
                        console.log(playing);
                        if (!playing) {
                            playing = true;
                            videoTag.play();
                            video.classList.add('playing');
                        } else {
                            playing = false;
                            videoTag.pause();
                            video.classList.remove('playing');
                        }
                    });
                }
            });
        }

        const homeVidBtn = document.querySelector('.home-header__play-btn');
        if (homeVidBtn) {
            const videoTag = document.querySelector('.home-header__video');
            let paused = homeVidBtn.classList.contains('home-header__play-btn--paused');
            homeVidBtn.addEventListener('click', () => {
                if (!paused) {
                    paused = true;
                    videoTag.pause();
                    homeVidBtn.classList.add('home-header__play-btn--paused');
                    homeVidBtn.ariaLabel = homeVidBtn.dataset.ariaLabelPlay;
                } else {
                    paused = false;
                    videoTag.play();
                    homeVidBtn.classList.remove('home-header__play-btn--paused');
                    homeVidBtn.ariaLabel = homeVidBtn.dataset.ariaLabelPause;
                }
            });
        }
    },
};

export default Video;
